export default {
	profileFollowing: [],
	profileFollowingLimit: 10,
	profileFollowingOffset: 0,
	profileFollowingFetchCompleted: false 
}